import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { KonektoNavbar } from '../../components'
import './ForgotPassword.scss'
import Footer from '../../components/footer/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { validateEmail } from '../../helpers'
import { authService } from '../../services/authService'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function ForgotPassword() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { token } = useSelector(state => state.authentication)

  const [email, setEmail] = useState('')

  const [emailError, setEmailError] = useState(null)

  const [requestError, setRequestError] = useState(null)
  const [requestLoader, setRequestLoader] = useState(false)

  const onPasswordReset = async e => {
    setRequestError(null)
    e.preventDefault()

    const isEmailValid = validateEmail(email)
    if (!isEmailValid) {
      setEmailError('Email nije validan')
      return
    }

    setRequestLoader(true)

    const response = await authService.passwordReset({ email })
    if (response.isOk && response.data) {
      toast.success(response.data.message)
      navigate('/prijava')
    } else {
      setRequestError(response.message)
    }

    setRequestLoader(false)
  }

  useEffect(() => {
    if (token) {
      navigate('/')
    }
  }, [token, navigate])

  return (
    <div id="forgot-password">
      <KonektoNavbar />

      <div className="container d-flex justify-content-center my-5">
        <div className="card p-4 shadow py-4" style={{ width: '380px' }}>
          <h4 className="text-center mb-4">Zaboravljena lozinka</h4>
          <form onSubmit={onPasswordReset}>
            <div className="form-group mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control rounded-pill"
                id="email"
                placeholder="Unesite email"
                value={email || ''}
                onChange={e => {
                  setEmail(e.target.value)
                  if (emailError) {
                    setEmailError(null)
                  }
                }}
              />
              {emailError ? (
                <span className="field-error">{emailError}</span>
              ) : null}
            </div>

            <button
              type="submit"
              disabled={requestLoader}
              className="btn btn-primary btn-block w-100 mt-3 mb-2 rounded-pill">
              {requestLoader ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                'Pošalji zahtjev'
              )}
            </button>

            {requestError ? (
              <p className="field-error text-center mb-0 mt-2">
                {requestError}
              </p>
            ) : null}
          </form>
        </div>
      </div>

      <Footer />
    </div>
  )
}
